var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4531 36L49.5 57.0009L43.7735 63L18 36L43.7735 9L49.5 14.9991L29.4531 36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronLeft);
export default __webpack_public_path__ + "static/media/ic_chevron_left.f824fc8d810b9e97f1e86be626cd2b25.svg";
export { ForwardRef as ReactComponent };